<template>
  <div class="card modal-usuario">
    <header class="card-header">
      <p class="card-header-title" style="font-size: large">
        {{ creado ? t.listo[iso] : esEdicion ? t.editarUsuario[iso] : i18n.createUser[iso] }}
      </p>
      <button class="card-header-icon" aria-label="cerrar" @click="$emit('close')">
        <span class="icon"><i class="fas fa-times" aria-hidden="true"></i></span>
      </button>
    </header>

    <!-- Después de crear: los datos de acceso para compartirlos (la contraseña no se vuelve a ver) -->
    <div v-if="creado" class="card-content">
      <b-message type="is-success" :closable="false">
        {{ t.creadoAviso[iso] }}
      </b-message>
      <table class="table is-fullwidth is-narrow">
        <tbody>
          <tr>
            <th>{{ i18n.user[iso] }}</th>
            <td>{{ creado.Usuario }}</td>
          </tr>
          <tr>
            <th>{{ i18n.email[iso] }}</th>
            <td>{{ creado.Email }}</td>
          </tr>
          <tr>
            <th>{{ i18n.password[iso] }}</th>
            <td><code>{{ creado.Password }}</code></td>
          </tr>
          <tr>
            <th>{{ t.entrar[iso] }}</th>
            <td>{{ urlBackoffice }}</td>
          </tr>
        </tbody>
      </table>
      <div class="buttons is-right">
        <b-button icon-left="copy" icon-pack="fas" @click="copiarAcceso">{{ t.copiar[iso] }}</b-button>
        <b-button type="is-success" @click="$emit('close')">{{ t.cerrar[iso] }}</b-button>
      </div>
    </div>

    <template v-else>
      <div class="card-content">
        <div class="columns is-multiline">
          <div class="column is-12-mobile is-4-tablet">
            <b-field :label="`${i18n.name[iso]} *`" :label-position="labelPosition" v-bind="error('Nombre')">
              <b-input v-model="user.Nombre" maxlength="40" :has-counter="false"></b-input>
            </b-field>
          </div>
          <div class="column is-12-mobile is-4-tablet">
            <b-field :label="i18n.lastname[iso]" :label-position="labelPosition">
              <b-input v-model="user.Apellido" maxlength="40" :has-counter="false"></b-input>
            </b-field>
          </div>
          <div class="column is-12-mobile is-4-tablet">
            <b-field :label="`${i18n.email[iso]} *`" :label-position="labelPosition" v-bind="error('Email')">
              <b-input v-model="user.Email" type="email" maxlength="80" :has-counter="false"></b-input>
            </b-field>
          </div>

          <div class="column is-12-mobile is-4-tablet">
            <b-field :label="`${i18n.user[iso]} *`" :label-position="labelPosition" v-bind="error('Usuario')">
              <b-input v-model="user.Usuario" maxlength="30" :has-counter="false"></b-input>
            </b-field>
          </div>
          <div class="column is-12-mobile is-8-tablet">
            <b-field
              :label="esEdicion ? t.nuevaContrasena[iso] : `${i18n.password[iso]} *`"
              :label-position="labelPosition"
              v-bind="error('Password', esEdicion ? t.contrasenaAyuda[iso] : '')"
            >
              <b-input
                v-model="user.Password"
                type="password"
                password-reveal
                expanded
                autocomplete="new-password"
              ></b-input>
              <p class="control">
                <b-button icon-left="dice" icon-pack="fas" @click="generarContrasena">{{ t.generar[iso] }}</b-button>
              </p>
            </b-field>
          </div>

          <div class="column is-12-mobile is-4-tablet">
            <b-field
              :label="`${i18n.role[iso]} *`"
              :label-position="labelPosition"
              v-bind="error('Rol', esYo ? t.rolPropio[iso] : '')"
            >
              <b-select v-model="user.Rol" expanded :disabled="esYo">
                <option :value="null"></option>
                <option v-for="rol in rolesDisponibles" :value="rol._id" :key="rol._id">
                  {{ nombreRol(rol) }}{{ rol.Activo === false ? ` (${t.inactivo[iso]})` : "" }}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-12-mobile is-4-tablet">
            <b-field :label="i18n.language[iso]" :label-position="labelPosition">
              <b-select v-model="user.Idioma" expanded>
                <option :value="null"></option>
                <option v-for="l in languages || []" :value="l.Id" :key="l.Id">
                  {{ iso === "en" ? l.NombreEn : l.Nombre }}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-12-mobile is-4-tablet">
            <b-field label="Club" :label-position="labelPosition">
              <b-select v-model="user.ClubId" expanded :loading="cargandoClubs" @input="cambiarClub">
                <option :value="null"></option>
                <option v-for="c in listaClubs" :value="c.Id" :key="c._id || c.Id">
                  {{ c.Nombre }}
                </option>
              </b-select>
            </b-field>
          </div>

          <div class="column is-12" v-if="user.ClubId">
            <hr class="my-2" />
            <p class="has-text-weight-bold mb-2">{{ t.distribuidores[iso] }}</p>
            <div v-if="cargandoDistribuidores">{{ t.cargando[iso] }}</div>
            <div v-else>
              <b-field grouped>
                <b-select v-model="distribuidorNuevo" expanded :disabled="!distribuidoresLibres.length">
                  <option :value="null">
                    {{ distribuidoresLibres.length ? t.elegir[iso] : t.sinDistribuidores[iso] }}
                  </option>
                  <option v-for="d in distribuidoresLibres" :value="d.Id" :key="d._id || d.Id">
                    {{ d.Nombre }}
                  </option>
                </b-select>
                <p class="control">
                  <b-button
                    icon-left="plus"
                    icon-pack="fas"
                    type="is-success"
                    :disabled="!distribuidorNuevo"
                    @click="agregarDistribuidor"
                    >{{ t.agregar[iso] }}</b-button
                  >
                </p>
              </b-field>
              <b-taglist>
                <b-tag
                  v-for="d in distribuidoresElegidos"
                  :key="d.Id"
                  type="is-info is-light"
                  closable
                  @close="quitarDistribuidor(d.Id)"
                  >{{ d.Nombre }}</b-tag
                >
                <span v-if="!distribuidoresElegidos.length" class="has-text-grey is-size-7">
                  {{ t.ningunDistribuidor[iso] }}
                </span>
              </b-taglist>
            </div>
          </div>
        </div>
      </div>
      <footer class="card-footer">
        <a
          @click="$emit('close')"
          class="card-footer-item button is-danger is-outlined is-small"
          style="height: auto"
          ><b>{{ i18n.cancel[iso] }}</b></a
        >
        <a
          :class="`card-footer-item button is-success is-outlined is-small ${guardando ? 'is-loading' : ''}`"
          style="height: auto"
          @click="guardar"
          ><b>{{ i18n.save[iso] }}</b></a
        >
      </footer>
    </template>
  </div>
</template>

<script>
import axios from "axios";
import i18n from "../../utils/i18n";

const API_URL = process.env.VUE_APP_API_URL;

// Mismas reglas que la API (services/system.js)
const CORREO_VALIDO = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const USUARIO_VALIDO = /^[\p{L}0-9._ -]{2,30}$/u;
const CAMPOS = ["Nombre", "Apellido", "Email", "Usuario", "Rol", "Idioma", "ClubId", "Distributors"];

const t = {
  editarUsuario: { es: "Editar usuario", en: "Edit user" },
  listo: { es: "Usuario creado", en: "User created" },
  creadoAviso: {
    es: "Comparte estos datos de acceso con la persona. La contraseña no se vuelve a mostrar.",
    en: "Share these login details. The password won't be shown again.",
  },
  entrar: { es: "Entrar en", en: "Log in at" },
  copiar: { es: "Copiar datos", en: "Copy details" },
  copiado: { es: "Datos copiados", en: "Details copied" },
  cerrar: { es: "Listo", en: "Done" },
  nuevaContrasena: { es: "Nueva contraseña", en: "New password" },
  contrasenaAyuda: { es: "Déjala vacía para no cambiarla", en: "Leave empty to keep it" },
  generar: { es: "Generar", en: "Generate" },
  rolPropio: { es: "No puedes cambiar tu propio rol", en: "You can't change your own role" },
  inactivo: { es: "inactivo", en: "inactive" },
  distribuidores: { es: "Distribuidores", en: "Distributors" },
  cargando: { es: "Cargando…", en: "Loading…" },
  elegir: { es: "Elige un distribuidor", en: "Choose a distributor" },
  sinDistribuidores: { es: "No hay más distribuidores en este club", en: "No more distributors in this club" },
  ningunDistribuidor: { es: "Sin distribuidores asignados", en: "No distributors assigned" },
  agregar: { es: "Agregar", en: "Add" },
  sinCambios: { es: "No hay cambios que guardar", en: "Nothing to save" },
  actualizado: { es: "Usuario actualizado", en: "User updated" },
  errorGuardar: { es: "Error al guardar el usuario", en: "Error saving user" },
  sesion: { es: "Tu sesión ya no es válida, vuelve a iniciar sesión", en: "Your session expired, please log in again" },
  faltaNombre: { es: "Escribe el nombre", en: "Enter the name" },
  correoInvalido: { es: "El correo no es válido", en: "Invalid email" },
  usuarioInvalido: {
    es: "De 2 a 30 caracteres: letras, números, espacio, punto o guion",
    en: "2 to 30 characters: letters, numbers, space, dot or dash",
  },
  contrasenaCorta: { es: "Al menos 8 caracteres", en: "At least 8 characters" },
  faltaRol: { es: "Elige un rol", en: "Choose a role" },
};

const generar = () => {
  // Sin caracteres que se confunden al dictarlos (0/O, 1/l/I)
  const letras = "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789";
  const simbolos = "!@#$%*";
  const azar = new Uint32Array(12);
  window.crypto.getRandomValues(azar);
  const base = Array.from(azar.slice(0, 11), (n) => letras[n % letras.length]).join("");
  return base + simbolos[azar[11] % simbolos.length];
};

const copiaUsuario = (u) => ({
  Nombre: u?.Nombre || "",
  Apellido: u?.Apellido || "",
  Email: u?.Email || "",
  Usuario: u?.Usuario || "",
  Password: "",
  Rol: u?.Rol ? (typeof u.Rol === "object" ? u.Rol._id : u.Rol) : null,
  Idioma: u?.Idioma || null,
  ClubId: u?.ClubId || null,
  Distributors: Array.isArray(u?.Distributors) ? [...u.Distributors] : [],
});

export default {
  name: "ModalCreateUserSystem",
  props: ["roles", "languages", "userToEdit", "clubs"],
  data() {
    return {
      i18n,
      t,
      iso: localStorage.getItem("iso") || "es",
      labelPosition: "on-border",
      guardando: false,
      intentoGuardar: false,
      errorApi: null,
      creado: null,

      original: copiaUsuario(this.userToEdit),
      user: copiaUsuario(this.userToEdit),

      clubsPropios: [],
      cargandoClubs: false,
      distribuidores: [],
      cargandoDistribuidores: false,
      distribuidorNuevo: null,
    };
  },
  computed: {
    esEdicion() {
      return Boolean(this.userToEdit?._id);
    },
    esYo() {
      return this.esEdicion && String(this.userToEdit._id) === String(localStorage.getItem("userId"));
    },
    listaClubs() {
      return this.clubs?.length ? this.clubs : this.clubsPropios;
    },
    // Para asignar solo roles activos; si el usuario ya tiene uno inactivo, se sigue mostrando
    rolesDisponibles() {
      return (this.roles || [])
        .filter((r) => r.Activo !== false || r._id === this.original.Rol)
        .sort((a, b) => this.nombreRol(a).localeCompare(this.nombreRol(b)));
    },
    distribuidoresLibres() {
      return this.distribuidores.filter((d) => !this.user.Distributors.includes(d.Id));
    },
    distribuidoresElegidos() {
      return this.user.Distributors.map(
        (id) => this.distribuidores.find((d) => d.Id === id) || { Id: id, Nombre: id },
      );
    },
    errores() {
      const u = this.user;
      const e = {};
      if (!u.Nombre.trim()) e.Nombre = t.faltaNombre[this.iso];
      if (!CORREO_VALIDO.test(u.Email.trim())) e.Email = t.correoInvalido[this.iso];
      if (!USUARIO_VALIDO.test(u.Usuario.trim())) e.Usuario = t.usuarioInvalido[this.iso];
      if ((!this.esEdicion || u.Password) && u.Password.length < 8) e.Password = t.contrasenaCorta[this.iso];
      if (!u.Rol) e.Rol = t.faltaRol[this.iso];
      return e;
    },
    urlBackoffice() {
      return window.location.origin;
    },
  },
  async created() {
    this.$bus.on("change-iso", this.cambiarIdioma);
    if (!this.clubs?.length) await this.cargarClubs();
    if (this.user.ClubId) await this.cargarDistribuidores(this.user.ClubId);
  },
  beforeDestroy() {
    this.$bus.off("change-iso", this.cambiarIdioma);
  },
  methods: {
    cambiarIdioma() {
      this.iso = localStorage.getItem("iso") || "es";
    },
    nombreRol(rol) {
      return (this.iso === "en" && rol?.NombreEn) || rol?.Nombre || "";
    },
    // Mensaje del campo: solo después del primer intento de guardar, o la ayuda fija
    error(campo, ayuda = "") {
      const mensaje = this.intentoGuardar ? this.errores[campo] : null;
      return { type: mensaje ? "is-danger" : null, message: mensaje || ayuda || null };
    },
    generarContrasena() {
      this.user.Password = generar();
    },
    async cargarClubs() {
      this.cargandoClubs = true;
      try {
        const { data } = await axios.get(`${API_URL}/system/club/list`);
        this.clubsPropios = Array.isArray(data) ? data : data?.clubs || data?.data || [];
      } catch (err) {
        console.error("Error al cargar clubes:", err);
      } finally {
        this.cargandoClubs = false;
      }
    },
    async cargarDistribuidores(clubId) {
      if (!clubId) {
        this.distribuidores = [];
        return;
      }
      this.cargandoDistribuidores = true;
      try {
        const { data } = await axios.get(`${API_URL}/system/distributor/list`, {
          params: { ClubId: clubId, Activo: true },
        });
        this.distribuidores = data?.data || [];
      } catch (err) {
        console.error("Error al cargar distribuidores:", err);
        this.distribuidores = [];
      } finally {
        this.cargandoDistribuidores = false;
      }
    },
    async cambiarClub(clubId) {
      this.user.Distributors = [];
      this.distribuidorNuevo = null;
      await this.cargarDistribuidores(clubId);
    },
    agregarDistribuidor() {
      if (this.distribuidorNuevo && !this.user.Distributors.includes(this.distribuidorNuevo))
        this.user.Distributors.push(this.distribuidorNuevo);
      this.distribuidorNuevo = null;
    },
    quitarDistribuidor(id) {
      this.user.Distributors = this.user.Distributors.filter((d) => d !== id);
    },
    limpio() {
      const datos = {};
      for (const campo of CAMPOS) {
        const valor = this.user[campo];
        datos[campo] = typeof valor === "string" ? valor.trim() : valor;
      }
      return datos;
    },
    // En una edición solo viajan los campos que cambiaron
    cambios() {
      const datos = this.limpio();
      const cambios = {};
      for (const campo of CAMPOS) {
        if (JSON.stringify(datos[campo] ?? null) !== JSON.stringify(this.original[campo] ?? null))
          cambios[campo] = datos[campo];
      }
      if (this.user.Password) cambios.Password = this.user.Password;
      return cambios;
    },
    async guardar() {
      if (this.guardando) return;
      this.intentoGuardar = true;
      if (Object.keys(this.errores).length) return;

      this.guardando = true;
      try {
        if (this.esEdicion) {
          const cambios = this.cambios();
          if (!Object.keys(cambios).length) {
            this.$buefy.toast.open({ message: t.sinCambios[this.iso], type: "is-info" });
            this.$emit("close");
            return;
          }
          await axios.put(`${API_URL}/system/update-user/${this.userToEdit._id}`, cambios);
          this.$buefy.toast.open({ message: t.actualizado[this.iso], type: "is-success" });
          this.$emit("refreshUsers");
          this.$emit("close");
        } else {
          const datos = { ...this.limpio(), Password: this.user.Password };
          const { data } = await axios.post(`${API_URL}/system/create-user`, datos);
          this.creado = { Usuario: data?.Usuario || datos.Usuario, Email: data?.Email || datos.Email, Password: datos.Password };
          this.$emit("refreshUsers");
        }
      } catch (err) {
        console.log(err);
        const mensaje =
          err?.response?.status === 401 ? t.sesion[this.iso] : err?.response?.data?.error || t.errorGuardar[this.iso];
        this.$buefy.toast.open({ message: mensaje, type: "is-danger", duration: 5000 });
      } finally {
        this.guardando = false;
      }
    },
    async copiarAcceso() {
      const c = this.creado;
      const texto = [
        `${i18n.user[this.iso]}: ${c.Usuario}`,
        `${i18n.email[this.iso]}: ${c.Email}`,
        `${i18n.password[this.iso]}: ${c.Password}`,
        `${t.entrar[this.iso]}: ${this.urlBackoffice}`,
      ].join("\n");
      try {
        await navigator.clipboard.writeText(texto);
        this.$buefy.toast.open({ message: t.copiado[this.iso], type: "is-success" });
      } catch (e) {
        this.$buefy.toast.open({ message: texto, type: "is-info", duration: 10000 });
      }
    },
  },
};
</script>

<style scoped>
.modal-usuario {
  width: min(800px, 94vw);
}
</style>
